import { createCartState } from "./createCartState";

const cartStores = new Map<string, ReturnType<typeof createCartState>>();

export const useMarketCartState = (market?: string) => {
  const resolvedMarket = market ?? "se";

  if (!cartStores.has(resolvedMarket)) {
    cartStores.set(resolvedMarket, createCartState(resolvedMarket));
  }

  return cartStores.get(resolvedMarket)!;
};
